import { List, Map } from 'immutable';
import { EMPTY_LIST } from 'app/app.constants';
import { ACTIVITY_LOG_ACTIONS } from 'features/wells/overview/activityLog/helpers/activityLog.constants';

const initialState = Map({
  integrityManagementUsers: EMPTY_LIST,
  activityLogs: EMPTY_LIST,
});

const activityLogReducer = (state = initialState, action = {}) => {
  const { type } = action;

  switch (type) {
    case ACTIVITY_LOG_ACTIONS.GET_INTEGRITY_MANAGEMENT_USERS_BY_ORGANIZATION: {
      if (action.error) return state;

      return state.set('integrityManagementUsers', List(action.payload));
    }
    case ACTIVITY_LOG_ACTIONS.SEARCH_ACTIVITY_LOGS: {
      if (action.error) return state;

      return state.set('activityLogs', List(action.payload));
    }

    case ACTIVITY_LOG_ACTIONS.SEARCH_FIELD_ACTIVITY_LOGS: {
      if (action.error) return state;

      return state.set('fieldActivityLogs', List(action.payload));
    }
    default:
      return state;
  }
};

export default activityLogReducer;
